<template>
    <div class="apprentice-simple-card">
        <p v-if="this.groupIn.parent_id">
            {{ $t('group.show.adding_editing_internships_is_done_on_the_main_project') }}
        </p>
        <design-2021-apprentice-data-table
            :items="internships"
            :fields="internshipFields"
            :show-empty="true">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-internships"
                    v-if="!groupIn.parent_id"
                    v-b-modal="'add-internships-modal'"
                    type="button"
                    variant="primary"
                    :label="$t('group.show.add_internships')">
                    {{ $t('group.show.add_internships') }}
                </b-button>
            </template>
            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('group.show.no_internships_found') }}</div>
                </div>
            </template>
            <template v-slot:cell(action)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-remove btn-remove-faq-tag"
                        v-if="!groupIn.parent_id"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="excludeInternship(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-group-add-internships-modal-component
            ref="add-internships-modal"
            @addInternships="getInternships($event)"
            @reinclude-internship="reincludeInternship($event)"
            :excluded-internships-in="excludedInternships"
            :group-in="groupIn">
        </design-2021-group-add-internships-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-internship-types-component',
    props: ['groupIn'],
    data() {
        return {
            internships: [],
            excludedInternships: [],
        };
    },
    computed: {
        internshipFields() {
            let fields = [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'location',
                    label: this.$t('common.city'),
                },
                {
                    key: 'organization',
                    label: this.$t('common.organization'),
                },
            ];
            if (!this.groupIn.parent_id) {
                fields.push({
                    key: 'action',
                    label: this.$t('common.actions'),
                });
            }
            return fields;
        },
    },
    methods: {
        getInternships() {
            this.excludedInternships = this.groupIn.excluded_internships;
            this.axios.get(this.routes.groupInternships(this.groupIn.id)).then(
                (response) => {
                    this.internships = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        show() {
            if (!this.internships.length) {
                this.getInternships();
            }
        },
        excludeInternship(id) {
            let data = {
                internship_id: id,
                group_id: this.groupIn.id,
            };

            this.axios.post(this.routes.excludeInternshipFromGroup(this.groupIn.id), data).then(
                (response) => {
                    const internshipToExclude = this.internships.find((internship) => internship.id === id);
                    this.excludedInternships.push(internshipToExclude);
                    this.internships = this.internships.filter((internship) => internship.id !== id);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        reincludeInternship(internship) {
            this.excludedInternships = this.excludedInternships.filter((i) => i.id !== internship.id);
            this.internships.push(internship);
            this.alert.success();
        },
    },
};
</script>

<style scoped></style>
